module.exports = __webpack_public_path__ + "static/media/notification.e6f3c8fe.svg";